import { Send, ErrorCircle, CheckCircle } from '@ori-ui/icons';
import { styled } from '@ori-ui/mui';
import React from 'react';

export enum NewsletterTitleIconType {
  Submit = 'Submit',
  Subscribe = 'Subscribe',
  Error = 'Error',
}

interface Props {
  icon?: NewsletterTitleIconType;
}

const BaseIcon = styled('div')(({ theme }) => ({
  fontSize: '40px',
  marginBottom: theme.spacing(4),
  [theme.breakpoints.up('md')]: {
    fontSize: '60px',
  },
}));

const SendIcon = styled(BaseIcon)().withComponent(Send);

const CheckCircleIcon = styled(BaseIcon)(({ theme }) => ({
  color: theme.palette.success.main,
})).withComponent(CheckCircle);

const ErrorCircleIcon = styled(BaseIcon)(({ theme }) => ({
  color: theme.palette.error.main,
})).withComponent(ErrorCircle);

const titleIcons = {
  [NewsletterTitleIconType.Submit]: SendIcon,
  [NewsletterTitleIconType.Subscribe]: CheckCircleIcon,
  [NewsletterTitleIconType.Error]: ErrorCircleIcon,
};

export const TitleIcon: React.FC<Props> = ({ icon }) => {
  if (!icon) {
    return null;
  }

  const ResultIcon = titleIcons[icon];

  return <ResultIcon fontSize="inherit" />;
};
